
$views.accountresetpasswordconfirm = {
	
	isPrepopulated : false,
	
	display : function() {
		
		jQuery('#password').keyup(function () {
			$soupmail.sidetip.validatePassword();
		});
		
		jQuery('#password2').keyup(function () {
			$soupmail.sidetip.validatePassword2();
		});
		
		$views.accountresetpasswordconfirm.isPrepopulated = false;
		this.token = jQuery.getURLParameter('token');
		if (this.token) {
			$views.accountresetpasswordconfirm.token = this.token;
			$views.accountresetpasswordconfirm.isPrepopulated = true;
		}
		
	}
	
};

$views.accountexpired = {
	display : function() {}
};

$views.accountsetup = {
	display : function() {}
};

$views.accountcreate = {
	
	isPrepopulated : false,
	
	display : function() {
		
		jQuery('#password').keyup(function () {
			$soupmail.sidetip.validatePassword();
		});
		
		jQuery('#password2').keyup(function () {
			$soupmail.sidetip.validatePassword2();
		});
		
		jQuery('#email').bind('focusout keyup',function () {
			$soupmail.sidetip.validateEmail();
		});
		
		$views.accountcreate.isPrepopulated = false;
		this.token = jQuery.getURLParameter('token');
		if (this.token) {
			$views.accountcreate.token = this.token;
			$views.accountcreate.isPrepopulated = true;
		}
		
		var $emailaddress = jQuery.getURLParameter('email');
		if ($emailaddress) {
			jQuery('#email').val($emailaddress);
			jQuery('#email').attr('readonly', 'readonly');
			jQuery('#email').addClass('readonly');
			jQuery('.fields.team_name').hide();
		}
		
		var $firstname = jQuery.getURLParameter('first_name');
		if ($firstname) {
			jQuery('#first_name').val($firstname);
		}
		
		var $lastname = jQuery.getURLParameter('last_name');
		if ($lastname) {
			jQuery('#last_name').val($lastname);
		}
		
		var $teamname = jQuery.getURLParameter('team_name');
		var $signuptype = jQuery.getURLParameter('signup_type');
		switch ($signuptype) {
			case 'folder_share':
				jQuery('#main h1').html("<strong>You've been invited</strong> to join a shared folder");
				jQuery('#team_name').val('');
				jQuery('.fields.team_name').show();
			break;
			case 'team_add':
				jQuery('#main h1').text($teamname).prepend("<strong>You've been invited</strong> to join a team called<br />'").append("' on Soup Mail.");
				if ($teamname) {
					jQuery('#team_name').val($teamname);
					jQuery('#team_name').attr('readonly', 'readonly');
					jQuery('#team_name').addClass('readonly');
					jQuery('#team_name').removeAttr('name');
					jQuery('.fields.team_name').show();
				}
			break;
			default:
				jQuery('#main h1').html('<strong>Create</strong> a Soup Mail account');
				jQuery('#team_name').val('');
				jQuery('.fields.team_name').show();
			break;
		}
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/views/accounts.js